import * as Cesium from 'cesium';
import styled from "styled-components";
import Accordion from "../../../Accordion";
import { AnnotationTypes } from "constant";
import { Straighten } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import AccordionItem from "../../../Accordion/AccordionItem";
import useViewerStore from '../../../../store-zustand/viewer';
import useProjectStore from '../../../../store-zustand/project';
import { ManageAnnotationList, manageEntityVisibilityById } from "../../../MapView/MapUtils";

const AddAnnotationsBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 50px;
  font-size: ${({ theme }) => theme.font.size.text.small};
  margin: 2.5rem auto;
  border: 1px dashed ${({ theme }) => theme.textColor.secondary} !important;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  color: #a0a0a0;
  svg {
    width: 20px;
    height: 20px;
    margin-right: 24px;
    transform: rotate(-45deg);
  }

  &:hover {
    border: 1px dashed #E5E5E5 !important;
    color: #E5E5E5;

    svg {
      path {
        fill: #E5E5E5 !important;
      }
    }
  }
`;

const Annotations = (props) => {
  const { viewer } = useViewerStore();
  const { onSelect, onEdit, projectID, onDelete } = props;
  const [annotationdata, setannotationdata] = useState([]);
  const [createAnnotations, setCreateAnnotations] = useState(true);
  const { getannotationbyproject, currentAnnotationId, reloadAnnotationsList } = useProjectStore();

  useEffect(() => {
    if (window.hasOwnProperty('handlerEditPolygonGeom')) {
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
      delete window['handlerEditPolygonGeom'];
    }

    setCreateAnnotations(true);
    window.annotationObj = [];
    if (window.hasOwnProperty('GlobalAnnotationEntities')) {
      window.GlobalAnnotationEntities.entities.removeAll();
    }

    let keyword = { IDPROJECT: projectID }
    getannotationbyproject(keyword).then((AnnotationList) => {
      if (AnnotationList.length > 0) {
        setCreateAnnotations(false);
      }

      if (window.GlobalAnnotationEntities) {
        viewer.dataSources.remove(window.GlobalAnnotationEntities);
      }

      window.GlobalAnnotationEntities = new Cesium.CustomDataSource("annotationData");
      var newAnnotationData = [];
      AnnotationList.forEach((obj, index) => {
        const annotation = ManageAnnotationList(viewer, obj, currentAnnotationId, AnnotationTypes);
        newAnnotationData.push(annotation);
        actualannotationIDwithVisibility(false, obj.pk);
      });

      setannotationdata(newAnnotationData);
      viewer.dataSources.add(window.GlobalAnnotationEntities);
      window.GlobalAnnotationEntities.show = true;
    })
  }, [reloadAnnotationsList])

  const actualannotationIDwithVisibility = async (flag, annotation, annotationIndex) => {
    await manageEntityVisibilityById(flag, annotation, viewer, annotationIndex);
  }

  if (annotationdata.length === 0) {
    return (
      <Accordion open sort add file heading="Annotations" id="annotations-accordion">
        {createAnnotations ?
          (<AddAnnotationsBtn><Straighten />Measure & Inspect</AddAnnotationsBtn>)
          :
          (<>Loading Data ...</>)
        }
      </Accordion>
    )
  } else {
    return (<Accordion open sort heading="Annotations" id="annotations-accordion">
      {annotationdata.map((item, index) => (
        <AccordionItem
          menutype={'AnnotaionEdition'}
          annotationId={item.annotationId}
          annotationIndex={index}
          key={index}
          keyword={projectID}
          icon={item.icon}
          label={item.label}
          onClick={() => onSelect(item, index)}
          onEdit={() => onEdit(item, index)}
          onDelete={() => onDelete(item)}
          type="annotation"
          actualannotationIDwithVisibility={actualannotationIDwithVisibility}
          lastaddedannotation={item.lastaddedannotation}
        />
      ))}
    </Accordion>)
  }
};

export default Annotations;